define(['jquery', 'core/ajax', 'core/str', 'core/url', 'sweetalert2', 'local_custom_auth/commonreg'
],
function($, ajax, str, moodleUrl, Swal, commonReg) {
    var index = {
        dom: {
            main: null
        },
        variable: {
            dataTableReference: null,
            pattern: /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
            noofseconds: 60,
            countDown: null
        },
        langs: {
            enterFirstName: null,
            enterLastName: null,
            pleaseProvideDOB: null,
            eligibilityByYears: null,
            selectState: null,
            pleaseSelectDistrict: null,
            enterEmail: null,
            enterValidEmail: null,
            enterValidOtp: null,
            enterMobileNo: null,
            validPhoneNumber: null,
            pleaseAcceptTermAndCon: null,
            enterOtp: null,
            pleaseWait: null,
            onlyNumberAreAllowed: null,
            thanksForSubmittingTheForm: null,
            oops: null,
            resendOtpinXSeconds: null,
            resendOtp: null,
            processing: null,
            selectDistrict: null,
            submitButton: null,
        },
        action: {
            getString: function() {
                str.get_strings([
                    {key: 'enterfirstname', component: 'local_custom_auth'},
                    {key: 'enterlastname', component: 'local_custom_auth'},
                    {key: 'pleaseprovidedob', component: 'local_custom_auth'},
                    {key: 'eligibilitybyyears', component: 'local_custom_auth'},
                    {key: 'selectstate', component: 'local_custom_auth'},
                    {key: 'pleaseselectdistrict', component: 'local_custom_auth'},
                    {key: 'enteremail', component: 'local_custom_auth'},
                    {key: 'entervalidemail', component: 'local_custom_auth'},
                    {key: 'entervalidotp', component: 'local_custom_auth'},
                    {key: 'entermobileno', component: 'local_custom_auth'},
                    {key: 'valid_phone_number', component: 'local_custom_auth'},
                    {key: 'pleaseaccepttermandcon', component: 'local_custom_auth'},
                    {key: 'enterotp', component: 'local_custom_auth'},
                    {key: 'pleasewait', component: 'local_custom_auth'},
                    {key: 'onlynumberareallowed', component: 'local_custom_auth'},
                    {key: 'thanksforsubmittingtheform', component: 'local_custom_auth'},
                    {key: 'oops', component: 'local_custom_auth'},
                    {key: 'resendotpinXseconds', component: 'local_custom_auth'},
                    {key: 'resendotp', component: 'local_custom_auth'},
                    {key: 'processing', component: 'local_custom_auth'},
                    {key: 'selectdistrict', component: 'local_custom_auth'},
                    {key: 'submitbutton', component: 'local_custom_auth'},
                ]).then(function(s) {
                    index.langs.enterFirstName = s[0];
                    index.langs.enterLastName = s[1];
                    index.langs.pleaseProvideDOB = s[2];
                    index.langs.eligibilityByYears = s[3];
                    index.langs.selectState = s[4];
                    index.langs.pleaseSelectDistrict = s[5];
                    index.langs.enterEmail = s[6];
                    index.langs.enterValidEmail = s[7];
                    index.langs.enterValidOtp = s[8];
                    index.langs.enterMobileNo = s[9];
                    index.langs.validPhoneNumber = s[10];
                    index.langs.pleaseAcceptTermAndCon = s[11];
                    index.langs.enterOtp = s[12];
                    index.langs.pleaseWait = s[13];
                    index.langs.onlyNumberAreAllowed = s[14];
                    index.langs.thanksForSubmittingTheForm = s[15];
                    index.langs.oops = s[16];
                    index.langs.resendOtpinXSeconds = s[17];
                    index.langs.resendOtp = s[18];
                    index.langs.processing = s[19];
                    index.langs.selectDistrict = s[20];
                    index.langs.submitButton = s[21];
                    index.init();
                }).fail(function(e) {});
            },
            createCandidate: function() {
                $('#btn-save-changes').html(index.langs.processing).attr('disabled', true);
                var promises = ajax.call([{
                    methodname: 'local_custom_auth_candidate_registration',
                    args: {
                        fname: index.dom.firstName.val().trim(),
                        lname: index.dom.lastName.val().trim(),
                        phone: index.dom.phone.val().trim(),
                       //otp: index.dom.validateOtp.val().trim(),
                        email: index.dom.email.val().trim().toLowerCase(),
                        clg_or_org: index.dom.clg_or_org.val().trim().toLowerCase(),
                       //emailotp: index.dom.validatEmailOtp.val().trim(),
                        accept: index.dom.acceptTC.prop('checked'),
                        //state: index.dom.state.val(),
                        //district: index.dom.district.val(),
                        //dob: index.dom.dob.val(),
                    }
                }]);
                promises[0].done(function(result) {
                    if (result.status == true) {
                        // Swal.fire({
                        //     position: "center",
                        //     icon: "success",
                        //     title: index.langs.thanksForSubmittingTheForm,
                        //     showConfirmButton: false,
                        //     timer: 3000
                        // });
                        // setTimeout(function() {
                        //     location.reload();
                        // }, 1500);
                        $("#newuserid").val(result.userid);
                        index.action.initiateCounter();
                        index.action.postCounter();
                        $("#verifyEmail").modal("show");
                    } else {
                        Swal.fire({
                            position: 'center',
                            title: index.langs.oops,
                            text: result.message,
                            imageUrl: './pix/error.png',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        $('#btn-save-changes').html(index.langs.submitButton).attr('disabled', false);
                    }
                }).fail(function() {
                });
            },
            resetValidationError: function() {
                index.dom.firstNameRequired.html('');
                index.dom.lastNameRequired.html('');
               // index.dom.requiredDOB.html('');
                index.dom.requiredMobile.html('');
               // index.dom.mobileValidateError.html('');
                index.dom.emailValidateError.html('');
                index.dom.emailExistError.html('');
                index.dom.requiredEmail.html('');
                // index.dom.requiredState.html('');
                // index.dom.requiredDistrict.html('');
            },
            initSpeciaCharactersCheck: function(e) {
                if ($.isNumeric(e.originalEvent.key)) {
                    return false;
                }
                var k = e.which;
                var allow = k >= 65 && k <= 90 || // A-Z
                k >= 97 && k <= 122 || // A-z
                k == 32;

                if (!allow) {
                    e.preventDefault();
                }
            },
            initValidateOtp: function(e) {
                var regExp = new RegExp('[a-zA-Z]');
                var value = String.fromCharCode(e.which) || e.key;
                if (regExp.test(value)) {
                    index.dom.emailOtpValidateRequired.html(index.langs.onlyNumberAreAllowed).css({color: 'red'});
                    return false;
                }
            },
            fieldValidationError: function() {
                index.action.resetValidationError();
                // var today = new Date();
                // var dob = new Date(index.dom.dob.val());
                // var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
                // var minage = 16;
                if (index.dom.firstName.val().trim() == '') {
                    index.dom.firstNameRequired.html(index.langs.enterFirstName).css({color: 'red'});
                    return false;
                } else if (index.dom.lastName.val().trim() == '') {
                    index.dom.lastNameRequired.html(index.langs.enterLastName).css({color: 'red'});
                    return false;
                // } else if (index.dom.dob.val().trim() == '') {
                //     index.dom.requiredDOB.html(index.langs.pleaseProvideDOB).css({color: 'red'});
                //     return false;
                // } else if (age < minage) {
                //     index.dom.requiredDOB.html(index.langs.eligibilityByYears).css({color: 'red'});
                //     return false;
                // } else if (index.dom.state.val() == '') {
                //     index.dom.requiredState.html(index.langs.selectState).css({color: 'red'});
                //     return false;
                // } else if (index.dom.district.val() === null) {
                //     index.dom.requiredDistrict.html(index.langs.pleaseSelectDistrict).css({color: 'red'});
                //     return false;
                } else if (index.dom.email.val().trim() == '') {
                    index.dom.requiredEmail.html(index.langs.enterEmail).css({color: 'red'});
                    return false;
                } else if (!index.variable.pattern.test(index.dom.email.val().trim())) {
                    index.dom.emailValidateError.html(index.langs.enterValidEmail).css({color: 'red'});
                    return false;
                } else {
                    return true;
                }
            },
            postCounter: function() {
              setTimeout(function() {
                clearInterval(index.variable.countDown);
                index.variable.noofseconds = 60;
                $('#resend-email').html('Resend OTP').attr('disabled', false);
              }, 60000);
              },
              initiateCounter: function() {
                $('#resend-email').html('Resend OTP in 60 s').attr('disabled', true);
                index.variable.countDown = setInterval(function () {
                  index.variable.noofseconds -= 1;
                  $('#resend-email').html('Resend OTP in '+ index.variable.noofseconds + ' secs');
                }, 1000);
              }
        },
        init: function() {
            index.dom.main = $(document).find('#candidateModal');
            index.dom.firstNameRequired = index.dom.main.find('#firstnameRequired');
            index.dom.lastNameRequired = index.dom.main.find('#lastnameRequired');
            index.dom.requiredMobile = index.dom.main.find('#requiredmobile');
            index.dom.emailValidateError = index.dom.main.find('#emailvalidateerror');
            index.dom.emailExistError = index.dom.main.find('#emailexisterror');
            index.dom.requiredEmail = index.dom.main.find('#requiredemail');

            index.dom.firstName = index.dom.main.find('#firstname');
            index.dom.lastName = index.dom.main.find('#lastname');
            index.dom.phone = index.dom.main.find('#phone');
            //index.dom.validateOtp = index.dom.main.find('#validate_otp');
            index.dom.email = index.dom.main.find('#email');
            index.dom.clg_or_org = index.dom.main.find('#clg_or_org');
            index.dom.acceptTC = index.dom.main.find('#accepttc');

            index.dom.firstName.keypress(index.action.initSpeciaCharactersCheck);
            index.dom.lastName.keypress(index.action.initSpeciaCharactersCheck);
            index.dom.clg_or_org.keypress(index.action.initSpeciaCharactersCheck);
            // index.dom.dob.keydown(function(e) {
            //     return false;
            // });
            index.dom.phone.keypress(function(e) {
              var k = e.which;
              var value = index.dom.phone.val();
              if (value.length === 0 && (k < 54 || k > 57) || (k < 48 || k > 57)) {
                e.preventDefault();
              }               
          });
            // Form Validation Part .
            index.dom.main.on('click', '#btn-save-changes', function(e) {
                index.action.resetValidationError();
                var validateion = index.action.fieldValidationError();
                if (validateion == false) {
                    return false;
                } else if (index.dom.phone.val().trim() == '') {
                    index.dom.requiredMobile.html(index.langs.enterMobileNo).css({color: 'red'});
                    return false;
                } else if (!$.isNumeric(index.dom.phone.val().trim()) || index.dom.phone.val().trim().length != 10) {
                    index.dom.requiredMobile.html(index.langs.validPhoneNumber).css({color: 'red'});
                    return false;
                } else if (!index.dom.acceptTC.is(':checked')) {
                    Swal.fire({
                        position: 'center',
                        title: index.langs.oops,
                        text: index.langs.pleaseAcceptTermAndCon,
                        imageUrl: './pix/error.png',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    return false;
                } else {
                    index.action.createCandidate();
                }
            });

            $("#verify-email").on("click", function(e) {
                var userid = $("#newuserid").val();
                var secretkey = $("#verification-code").val();
                var productid = 0;
                var subscriptionType = 2;
                var planid = 2;
                var usertype = 1;
                //console.log('Userid is' + userid);
        
                var promises = ajax.call([
                  {
                    methodname: "local_custom_auth_regconfirmUser",
                    args: {
                      userid: userid,
                      secretkey: secretkey,
                      subscriptionType: subscriptionType,
                      productid: productid,
                      planid: planid,
                      usertype: usertype
                    }
                  }
                ]);
        
                // disable button
                $(this).prop("disabled", true);
                // add spinner to button
                $(this).html(
                  '<i class="fa fa-circle-o-notch fa-spin"></i> Verifying...'
                );
                // hide wrong otp error message
                $("#wrong-otp").hide();
        
                promises[0]
                  .done(function(result) {
                    var res = result.split("~");
                    if (result === "wrongcode") {
                      // enable button
                      $("#verify-email").prop("disabled", false);
                      // remove spinner from button
                      $("#verify-email").html("Validate Code");
                      // show wrong otp error message
                      $("#wrong-otp").show();
                    } else if (res[0] == "m") {
                      $("#redirectionUrl").val(res[1]);
                      $("#verifyEmail").modal("hide");
                      $("#email-verified-m").modal("show");
                      // location.replace(res[1]);
                    } else if (res[0] == "p") {
                      var btname = res[1];
                      // $("#redirectionUrl").val(res[1]);                      
                      $("#verifyEmail").modal("hide");
                      $("#candidateModal").modal("hide");                      
                      $("#email-verified-p").modal("show");
                      $("#makepayment").on("click", function(e) {
                           window.location.href=btname;
                        });
                      
                    } else if (result === "email_failed") {
                      $("#verifyEmail").modal("hide");
                      $(document).scrollTop(0);
                      notification.addNotification({
                        type: "error",
                        message:
                          "Error occured while sending an email. Please contact Site Administrator."
                      });
                    } else {
                      //do nothing
                    }
                  })
                  .fail(function() {
                    $(document).scrollTop(0);
                    // notification.addNotification({
                    //   type: "error",
                    //   message: "ERROR !!!"
                    // });
                  });
              });


            $('#resend-email').on('click', function() {
            $('#resend-email').html('Sending otp ... ').attr('disabled', true);
            promises = ajax.call([{
              args: {
                    fname: index.dom.firstName.val().trim(),
                    lname: index.dom.lastName.val().trim(),
                    phone: index.dom.phone.val().trim(),
                    email: index.dom.email.val().trim().toLowerCase(),
                    accept: index.dom.acceptTC.prop('checked')
              },
              methodname: 'local_custom_auth_candidate_registration'
            }]);
            promises[0].done(function(result){
              if (result == "user_exist") {
                  $(document).scrollTop(0);
                  notification.addNotification({
                    type: "warning",
                    message: "NOTICE: User already registered, Try logging in ..."
                  });
                } else if (result == "email_failed") {
                  $(document).scrollTop(0);
                  notification.addNotification({
                    type: "error",
                    message:
                      "Error occured while sending an email. Please contact Site Administrator."
                  });
                } else {
                  $("#newuserid").val(result.userid);
                  index.action.initiateCounter();
                  index.action.postCounter();
                }
            }).fail(function(){

            })
          });

          $('#candidate-reg').on('click', function() {
            $('#btn-save-changes').html(index.langs.submitButton).attr('disabled', false);
          });

        }
    };
    return {
        init: index.action.getString
    };
});